interface CouponValidationSettings {
  enabled: boolean;
  exceptions: string[];
}

class MinicartCouponValidation {
  private readonly settings: CouponValidationSettings;
  private isUpdating = false;

  constructor() {
    const validationConfig = window.insiderTheme?.couponValidation;
    this.settings = {
      enabled: validationConfig?.enabled || false,
      exceptions: validationConfig?.exceptions || [],
    };
  }

  public init(): void {
    if (!this.settings.enabled) {
      return;
    }

    this.validateCurrentCartState();
  }

  private async validateCurrentCartState(): Promise<void> {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      if (cart) {
        this.handleCartUpdate({ cart });
      }
    } catch (error) {
      console.error('Error fetching initial cart state for validation:', error);
    }
  }

  private intToBRL(value: number): string {
    return (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  private async handleCartUpdate({ cart }: { cart: CartAPI }): Promise<void> {
    if (this.isUpdating || !cart.discount_codes || cart.discount_codes.length <= 1) {
      return;
    }

    const exactExceptions = new Set(this.settings.exceptions.filter(e => !e.includes('*')));
    const prefixExceptions = this.settings.exceptions
      .filter(e => e.includes('*'))
      .map(e => e.replace('*', ''));

    const appliedCodes = cart.discount_codes
      .filter(d => d.applicable)
      .map(d => d.code);

    const appliedCodesWithoutExceptions = appliedCodes.filter(code => {
      if (exactExceptions.has(code)) return false;
      return !prefixExceptions.some(prefix => code.startsWith(prefix));
    });

    if (appliedCodesWithoutExceptions.length <= 1) {
      return;
    }

    const couponToRemove = appliedCodesWithoutExceptions[appliedCodesWithoutExceptions.length - 1];
    const finalCodes = appliedCodes.filter(code => code !== couponToRemove);
    
    this.isUpdating = true;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: finalCodes.join(','),
        }),
      });
      const updateResponse = await response.json();
      if(updateResponse.total_price){
        document.getElementsByClassName("subtotal__header--value")[0].innerHTML = this.intToBRL(updateResponse.total_price);
      }
    } catch (error) {
      console.error('Error updating cart discounts:', error);
    } finally {
      setTimeout(() => {
        this.isUpdating = false;
      }, 500);
    }
  }
}

new MinicartCouponValidation().init();

